// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_ICSS_IMPORT_0___ = require("-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!./MapButtons.module.css");
var ___CSS_LOADER_GET_URL_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/getUrl.js");
var ___CSS_LOADER_URL_IMPORT_0___ = require("../../assets/images/button_icons/help.svg");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.aCbM68tG03cCqFq682AP {
    --icon-background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    --icon-background-size: 12px;
}

.toAR430rTEfuhIt64S1y {
}

.QAvpN1k2J1gM1b3SxKgO {
}

.kZ3MgELnwSjHWY72a9XH {
}

.XOFMjitx1LKCquzNBwZk {
}

.t2jzmlBT5AllZVaGx2_A ul {
    padding-bottom: 10px;
}

.jCfVukIbXsRkuUZmArpX {
    display: none;
}

.PjiSV5s8JhW9C_Jq0AOs {
}

.gQNTHDGA3y4f7CxNYCay {
}

.TTNFeB0itZRBZpQjonLZ {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 1rem 0;
    gap: 1rem;
}

#gw-map .TTNFeB0itZRBZpQjonLZ .BKGTX4qF1kS1dBeqvDIA p.map-body {
    font-size: calc(var(--map-body-font-size) * 0.875);
}

.PjiSV5s8JhW9C_Jq0AOs .TTNFeB0itZRBZpQjonLZ:first-of-type {
  padding-top: 0.25rem;
}

/* Divider between tip items */
.PjiSV5s8JhW9C_Jq0AOs .TTNFeB0itZRBZpQjonLZ + .TTNFeB0itZRBZpQjonLZ {
    border-top: 1px solid rgba(0,0,0,0.12);
    margin-top: 0; /* keep spacing controlled by padding */
}

.TTNFeB0itZRBZpQjonLZ:last-of-type {
    padding-bottom: 0;
}

.gvhI18T0CWNy1PXnzJro {
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 40px;
}

.gvhI18T0CWNy1PXnzJro .ofGlX_dVeSY5B3JzswhT {
    max-width: 100%;
    max-height: 100%;
    width: auto;
    height: auto;
    object-fit: contain;
}

.ofGlX_dVeSY5B3JzswhT {
    pointer-events: none;
}

/* Modifier for icons that are vertically biased (taller than wide).
   Make them fill the container height so they appear balanced with square icons. */
.gvhI18T0CWNy1PXnzJro.HIvIj7hGsl3V0S1KmKMP {
    height: 100%;
    width: auto;
    max-height: 100%;
}`, "",{"version":3,"sources":["webpack://./../core/components/map-buttons/HelpButton.module.css"],"names":[],"mappings":"AAAA;IAEI,gEAAoE;IACpE,4BAA4B;AAChC;;AAEA;AAEA;;AAEA;AAEA;;AAEA;AAEA;;AAEA;AAEA;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,aAAa;AACjB;;AAEA;AAEA;;AAEA;AAEA;;AAEA;IACI,aAAa;IACb,2BAA2B;IAC3B,mBAAmB;IACnB,eAAe;IACf,SAAS;AACb;;AAEA;IACI,kDAAkD;AACtD;;AAEA;EACE,oBAAoB;AACtB;;AAEA,8BAA8B;AAC9B;IACI,sCAAsC;IACtC,aAAa,EAAE,uCAAuC;AAC1D;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;mFACmF;AACnF;IACI,YAAY;IACZ,WAAW;IACX,gBAAgB;AACpB","sourcesContent":[".tipsToggleIcon {\r\n    composes: mapButtonIcon from './MapButtons.module.css';\r\n    --icon-background-image: url('@assets/images/button_icons/help.svg');\r\n    --icon-background-size: 12px;\r\n}\r\n\r\n.tipsContentContainer {\r\n    composes: mapContentContainer from './MapButtons.module.css';\r\n}\r\n\r\n.tipsHeaderContainer {\r\n    composes: mapButtonHeaderContainer from './MapButtons.module.css';\r\n}\r\n\r\n.tipsHeader {\r\n    composes: mapButtonHeader from './MapButtons.module.css';\r\n}\r\n\r\n.closeIcon {\r\n    composes: closeIcon from './MapButtons.module.css';\r\n}\r\n\r\n.tips ul {\r\n    padding-bottom: 10px;\r\n}\r\n\r\n.hidden {\r\n    display: none;\r\n}\r\n\r\n.tipItemsContainer {\r\n    composes: mapButtonContentContainer from './MapButtons.module.css';\r\n}\r\n\r\n.tipItemsContent {\r\n    composes: mapButtonContent from './MapButtons.module.css';\r\n}\r\n\r\n.tipItem {\r\n    display: flex;\r\n    justify-content: flex-start;\r\n    align-items: center;\r\n    padding: 1rem 0;\r\n    gap: 1rem;\r\n}\r\n\r\n:global(#gw-map) .tipItem .tipTextContainer p:global(.map-body) {\r\n    font-size: calc(var(--map-body-font-size) * 0.875);\r\n}\r\n\r\n.tipItemsContainer .tipItem:first-of-type {\r\n  padding-top: 0.25rem;\r\n}\r\n\r\n/* Divider between tip items */\r\n.tipItemsContainer .tipItem + .tipItem {\r\n    border-top: 1px solid rgba(0,0,0,0.12);\r\n    margin-top: 0; /* keep spacing controlled by padding */\r\n}\r\n\r\n.tipItem:last-of-type {\r\n    padding-bottom: 0;\r\n}\r\n\r\n.tipIconContainer {\r\n    width: 32px;\r\n    height: 32px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    flex: 0 0 40px;\r\n}\r\n\r\n.tipIconContainer .tipIcon {\r\n    max-width: 100%;\r\n    max-height: 100%;\r\n    width: auto;\r\n    height: auto;\r\n    object-fit: contain;\r\n}\r\n\r\n.tipIcon {\r\n    pointer-events: none;\r\n}\r\n\r\n/* Modifier for icons that are vertically biased (taller than wide).\r\n   Make them fill the container height so they appear balanced with square icons. */\r\n.tipIconContainer.tipIconVertical {\r\n    height: 100%;\r\n    width: auto;\r\n    max-height: 100%;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tipsToggleIcon": `aCbM68tG03cCqFq682AP ${___CSS_LOADER_ICSS_IMPORT_0___.locals["mapButtonIcon"]}`,
	"tipsContentContainer": `toAR430rTEfuhIt64S1y ${___CSS_LOADER_ICSS_IMPORT_0___.locals["mapContentContainer"]}`,
	"tipsHeaderContainer": `QAvpN1k2J1gM1b3SxKgO ${___CSS_LOADER_ICSS_IMPORT_0___.locals["mapButtonHeaderContainer"]}`,
	"tipsHeader": `kZ3MgELnwSjHWY72a9XH ${___CSS_LOADER_ICSS_IMPORT_0___.locals["mapButtonHeader"]}`,
	"closeIcon": `XOFMjitx1LKCquzNBwZk ${___CSS_LOADER_ICSS_IMPORT_0___.locals["closeIcon"]}`,
	"tips": `t2jzmlBT5AllZVaGx2_A`,
	"hidden": `jCfVukIbXsRkuUZmArpX`,
	"tipItemsContainer": `PjiSV5s8JhW9C_Jq0AOs ${___CSS_LOADER_ICSS_IMPORT_0___.locals["mapButtonContentContainer"]}`,
	"tipItemsContent": `gQNTHDGA3y4f7CxNYCay ${___CSS_LOADER_ICSS_IMPORT_0___.locals["mapButtonContent"]}`,
	"tipItem": `TTNFeB0itZRBZpQjonLZ`,
	"tipTextContainer": `BKGTX4qF1kS1dBeqvDIA`,
	"tipIconContainer": `gvhI18T0CWNy1PXnzJro`,
	"tipIcon": `ofGlX_dVeSY5B3JzswhT`,
	"tipIconVertical": `HIvIj7hGsl3V0S1KmKMP`
};
module.exports = ___CSS_LOADER_EXPORT___;
